/*=========================================================================================
  File Name: i18nCA.js
  Description: File đa ngôn ngữ cho phân hệ Quyx
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
    Author: pvduong1
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	QuickAddText: 'Thêm mới (F9)',
	QuickSearchText: 'Tìm nhanh (F3)',
	NumberPerPage: 'bản ghi trên',
	Page: 'trang',
	First: 'Đầu',
	Previous: 'Trước',
	Of: 'của',
	Next: 'Sau',
	Latest: 'Cuối',
	TotalItem: 'Tổng số bản ghi',
	TotalInvoice: 'Tổng số hóa đơn',
	TotalItemV1: 'Tổng số',
	ValidateLengthPassword: 'Ít nhất 8 ký tự',
	ValidateTextPassword: 'Chữ hoa,chữ thường',
	ValidateNumberPassword: 'Ít nhất 1 chữ số',

	ExpiredDateUseFrom: 'Thời hạn',
	NumberInvoiceStill: 'HĐ còn lại',

	TourGuide: {
		Guide1:
			'Bạn gửi hoặc chuyển tiếp (forward) email hóa đơn đến địa chỉ email này. Hệ thống sẽ tự động tra cứu và xử lý hóa đơn',
		Guide2:
			'Hóa đơn đầu vào sẽ lưu trữ tại đây. Bạn có thể xem kết quả xử lý hóa đơn, xuất khẩu để nhập vào phần mềm kế toán',
		Guide3: 'Quản lý danh sách Công ty, chi nhánh, phòng ban nhận hóa đơn'
	},

	FileProcess: {
		here: 'tại đây',
		HandInput: 'Chưa thực hiện nhập dữ liệu',
		FileYetProcess: count =>
			`Có ${count} hóa đơn chưa xử lý được. Hệ thống đang xử lý tốt nhất đối với hóa đơn XML. Vui lòng tải hóa đơn XML để kiểm tra`,
		InvoiceYetInput: numberError => `Còn ${numberError} hóa đơn chưa được thực hiện nhập dữ liệu`
	},

	Pagination: {
		Total: 'Tổng số',
		record: 'bản ghi',
		to: 'đến'
	},

	Notification: {
		NotificationNewForYou: numberNotification => `Bạn vừa nhận được ${numberNotification} thông báo mới`
	},

	Popup: {
		Guide: 'Hướng dẫn'
	},

	Progress: {
		Readied: 'Đã sẵn sàng',
		fail: 'thất bại',
		Preparing: 'Đang chuẩn bị',
		DownloadReady: 'Đã sẵn sàng tải xuống',
		DownloadFail: 'Tải xuống thất bại',
		DownloadPrepare: 'Đang chuẩn bị tải xuống'
	},

	Combobox: {
		NotData: 'Không tìm thấy dữ liệu'
	},

	//NVNAM3 : 1/5/2023
	Sidebar: {
		// Tiêu đề cho các step
		TitleStep2Bank: 'Hóa đơn',
		TitleStep3Bank: 'Cơ cấu tổ chức',
		TitleStep2Normal: 'Hóa đơn đầu vào',
		TitleStep3Normal: 'Hóa đơn đầu ra',
		TitleStep4Normal: 'Tờ khai hải quan',
		TitleStep5Normal: 'Cơ cấu tổ chức',
		TitleStep6Normal: 'Kết nối Cơ quan thuế',

		// Cho đơn vị CÓ đặc thù (Ngân hàng/Bảo hiểm/Kiểm toán)
		Step2Bank:
			'Hóa đơn sẽ lưu trữ tại đây. Bạn có thể xem kết quả xử lý hóa đơn, xuất khẩu để nhập vào phần mềm kế toán.',
		Step3Bank: linkhelp =>
			`<div style='margin-bottom: 8px'>Quản lý danh sách công ty, chi nhánh, phòng ban nhận hóa đơn.</div><div>Nếu bạn muốn kiểm tra hóa đơn của đơn vị mình thì thiết lập cơ cấu tổ chức theo hướng dẫn <a style='color: #00AAB7' href=${linkhelp} target='_blank'>tại đây</a>.</div>`,

		// Cho đơn vị KHÔNG có đặc thù
		Step2Normal:
			'Hóa đơn đầu vào sẽ lưu trữ tại đây. Bạn có thể xem kết quả xử lý hóa đơn, xuất khẩu để nhập vào phần mềm kế toán.',
		Step3Normal:
			'Hóa đơn đầu ra sẽ lưu trữ tại đây. Mỗi hóa đơn đầu ra được đưa vào chương trình sẽ được tính phí như hóa đơn đầu vào.',
		Step4Normal:
			'Tờ khai hải quan hàng nhập khẩu sẽ lưu trữ tại đây. Bạn có thể xem kết quả đọc tờ khai và xuất khẩu các báo cáo excel của tờ khai.',
		Step5Normal: linkhelp =>
			`<div style='margin-bottom: 8px'>Quản lý danh sách công ty, chi nhánh, phòng ban nhận hóa đơn.</div><div>Nếu bạn đóng vai trò như một ngân hàng, công ty bảo hiểm, công ty kiểm toán, cần kiểm tra hóa đơn của bên khác thì thiết lập cơ cấu tổ chức theo hướng dẫn <a style='color: #00AAB7' href=${linkhelp} target='_blank'>tại đây</a>.</div>`,
		Step6Normal: 'Kết nối với cơ quan thuế ngay tại đây để đồng bộ và xử lý hóa đơn tự động hàng ngày.',
		// Backward compatibility
		Step2:
			'Hóa đơn đầu vào sẽ lưu trữ tại đây. Bạn có thể xem kết quả xử lý hóa đơn, xuất khẩu để nhập vào phần mềm kế toán.',
		Step3: 'Quản lý danh sách Công ty, chi nhánh, phòng ban nhận hóa đơn.',

		// PBI-548352: Third Party Organization Mode Indicator
		ThirdPartyCheckMode: 'Sử dụng phần mềm để kiểm tra hóa đơn của bên thứ 3'
	},

	HeaderOptionFilter: {
		Filter: 'Lọc',
		UnFilter: 'Xóa bộ lọc',
		Cancel: 'Hủy bỏ',
		InputEmptyText: 'Nhập giá trị lọc',
		InputValueFrom: 'Giá trị lọc từ',
		InputValueTo: 'Đến',
		Status: 'Kết quả kiểm tra',
		Sticks: 'Nhãn dán',
		TypeInvoiceReceive: 'Nguồn hóa đơn',
		StatusInvoice: 'Trạng thái hóa đơn',
		StatusView: 'Trạng thái xem',
		InvoiceNo: 'Số hóa đơn',
		AmountPayment: 'Trạng thái thanh toán',
		CheckedVatStatus: 'Kiểm tra thuế suất',
		HasPdf: 'Invoice representation',
		HasXml: 'Invoice xml',
		SupplierCode: 'Mã đơn vị',
		SellerName: 'Nhà cung cấp',
		SellerAddress: 'Địa chỉ NCC',
		SellerTaxCode: 'Mã số thuế',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		TotalAmount: 'Tổng tiền',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		PaymentNumber: 'Số lần thanh toán',
		TotalAmountNotPayment: 'Tiền chưa thanh toán',
		BuyerName: 'Tên đơn vị mua hàng',
		BuyerAddress: 'Địa chỉ bên mua',
		Noted: 'Ghi chú',
		RefNo: 'Số chứng từ',
		Accountant: 'Người hạch toán',
		LicensePlate: 'Biển số xe',
		SignedDate: 'Ngày ký',
		IssueDate: 'Ngày cấp mã',
		CheckDate: 'Ngày kiểm tra',
		KindAccountingDate: 'Tình trạng hạch toán',
		InfoND123: {
			BuyerFullName: 'Người mua hàng'
		},
		SellerRiskStatus: 'Tình trạng rủi ro',
		CostType: 'Loại chi phí',
		BeyondTheNorm: 'Vượt định mức',
		CostNorms: 'Định mức chi phí',
		DeclarationNo: 'Số tờ khai',
		ExporterName: 'Người xuất khẩu',
		TotalDeclarationAmount: 'Total invoice amount'
	}
};
